export default "__VITE_ASSET__BbbNi1H5__"